import { Center, Icon } from '@chakra-ui/react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { ModalCloseButton } from '@/ui/ModalClosebutton';

export const SliderButtons = ({
  onClose = () => {},
  onPrev = () => {},
  onNext = () => {},
  applications = [],
  application = { appId: '0' },
  showNavItems = true,
}) => {
  return (
    <>
      <ModalCloseButton onClose={onClose} />
      {showNavItems && (
        <>
          {' '}
          <Center
            w="48px"
            h="48px"
            left="-60px"
            top="86px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={
              applications?.[applications?.length - 1]?.appId ===
              application?.appId
                ? 'not-allowed'
                : 'pointer'
            }
            onClick={onNext}
            opacity={
              applications?.[applications?.length - 1]?.appId ===
              application?.appId
                ? 0.5
                : 1
            }
            data-test-id="next-candidate-job-application-details-icon"
          >
            <Icon as={ChevronRightIcon} w="24px" h="24px" />
          </Center>
          <Center
            w="48px"
            h="48px"
            left="-60px"
            top="140px"
            pos="absolute"
            borderRadius="full"
            bg="#fff"
            cursor={
              applications?.[0]?.appId === application?.appId
                ? 'not-allowed'
                : 'pointer'
            }
            onClick={onPrev}
            opacity={applications?.[0]?.appId === application?.appId ? 0.5 : 1}
            data-test-id="previous-candidate-job-application-details-icon"
          >
            <Icon as={ChevronLeftIcon} w="24px" h="24px" />
          </Center>
        </>
      )}
    </>
  );
};
